module.exports = __webpack_public_path__ + "img/get-coupon-btn-bf-disabled.82aa9b19.png";